<div class="review-send-step">
  <p class="review-send-intro">{{ introText }}</p>

  <div class="detail-cards">
    <div class="detail-card">
      <div class="detail-card-label">{{ participantCardLabel }}</div>
      <div class="detail-row">
        <span class="detail-key">{{ participantNameLabel }}</span>
        <span class="detail-value">{{ participantName }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-key">{{ participantDobLabel }}</span>
        <span class="detail-value">{{ participantDob }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-key">{{ participantNdisNumberLabel }}</span>
        <span class="detail-value">{{ participantNdisNumber }}</span>
      </div>
    </div>

    <div class="detail-card">
      <div class="detail-card-label">{{ planCardLabel }}</div>
      <div class="detail-row">
        <span class="detail-key">{{ planTypeLabel }}</span>
        <span class="detail-value">{{ planTypeDisplay }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-key">{{ planStartLabel }}</span>
        <span class="detail-value">{{ planStartDisplay }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-key">{{ planEndLabel }}</span>
        <span class="detail-value">{{ planEndDisplay }}</span>
      </div>
    </div>

    <div class="detail-card" *ngIf="showGoalsCard">
      <div class="detail-card-label">{{ goalsCardLabel }}</div>
      <p class="detail-goals-text">{{ familyGoalsText }}</p>
    </div>
  </div>

  <div class="fee-box">
    <div class="fee-head">{{ feeHeading }}</div>
    <div class="fee-loading" *ngIf="isFeeSummaryLoading">
      {{ 'SERVICE_PLAN.STEP.REVIEW.FEE_SUMMARY_LOADING' | translate }}
    </div>
    <ng-container *ngIf="!isFeeSummaryLoading">
      <div
        class="fee-row"
        *ngFor="let row of feeRows"
        [class.zero]="row.isZero"
      >
        <span class="fee-row-label">
          <span class="fee-key">{{ row.labelKey | translate }}</span>
          <span class="fee-note" *ngIf="row.noteDisplay">{{
            row.noteDisplay
          }}</span>
        </span>
        <span class="fee-amount">{{ row.amountDisplay }}</span>
      </div>
      <div class="fee-total">
        <span class="fee-key">{{ totalFeeLabel }}</span>
        <span class="fee-amount">{{ totalFeeDisplay }}</span>
      </div>
    </ng-container>
  </div>

  <div class="actions">
    <app-action-button
      [kind]="isPreviewGenerated ? 'success' : 'filled'"
      color="primary"
      size="wide"
      [isDisabled]="isPreviewGenerated"
      (onClick)="generatePdf()"
    >
      {{ isPreviewGenerated ? pdfGeneratedLabel : generatePdfLabel }}
    </app-action-button>

    <ng-container *ngIf="pdfBlobUrl">
      <iframe
        class="pdf-preview-frame"
        [title]="pdfPreviewTitle"
        [src]="pdfBlobUrl | safe"
      ></iframe>

      <div class="pdf-accessible-summary">
        <h3>{{ accessibleSummaryHeading }}</h3>
        <p>
          {{ participantNameLabel }}: {{ participantName }};
          {{ participantDobLabel }}: {{ participantDob }};
          {{ participantNdisNumberLabel }}: {{ participantNdisNumber }}
        </p>
        <p>
          {{ planTypeLabel }}: {{ planTypeDisplay }}; {{ planStartLabel }}:
          {{ planStartDisplay }}; {{ planEndLabel }}: {{ planEndDisplay }}
        </p>
        <p>{{ totalFeeLabel }}: {{ totalFeeDisplay }}</p>
      </div>
    </ng-container>

    <div class="field-group" [class.surface-sunken]="isPrimaryEmailPrefilled">
      <app-text-input
        [control]="primaryEmailControl"
        [label]="primaryEmailLabel"
        type="email"
        [required]="true"
        [errorText]="primaryEmailErrorText"
        [describedBy]="
          isPrimaryEmailPrefilled ? primaryEmailControlId + '-prefilled' : null
        "
      />
      <app-prefilled-field-badge
        *ngIf="isPrimaryEmailPrefilled"
        [id]="primaryEmailControlId + '-prefilled'"
      />
    </div>

    <div
      class="field-group"
      *ngFor="
        let control of additionalEmailsArray.controls;
        let i = index;
        trackBy: trackByControl
      "
    >
      <app-text-input
        [control]="control"
        [label]="
          'SERVICE_PLAN.STEP.REVIEW.ADDITIONAL_RECIPIENT_LABEL'
            | translate: { index: i + 1 }
        "
        type="email"
        [errorText]="additionalEmailErrorText(control)"
      />
      <button
        type="button"
        class="remove-recipient-button"
        [attr.aria-label]="removeRecipientLabel"
        (click)="removeRecipient(i)"
      >
        &times;
      </button>
    </div>

    <app-action-button
      *ngIf="!isAtRecipientLimit"
      kind="outline"
      color="primary"
      size="wider"
      (onClick)="addRecipient()"
    >
      {{ addRecipientLabel }}
    </app-action-button>

    <app-action-button
      [kind]="isSendComplete ? 'success' : 'filled'"
      color="primary"
      size="wide"
      [isDisabled]="isSendButtonDisabled"
      (onClick)="onSend()"
    >
      {{ sendButtonLabel }}
    </app-action-button>

    <p class="review-send-reminder" *ngIf="isSendComplete">
      {{
        'SERVICE_PLAN.STEP.REVIEW.SENT_LINE'
          | translate: { allRecipientsDisplay }
      }}
    </p>
  </div>

  <div class="outcome-box" *ngIf="status" aria-live="polite">
    <h3 class="outcome-heading">
      {{ 'SERVICE_PLAN.STEP.REVIEW.OUTCOME_HEADING' | translate }}
    </h3>

    <div
      class="outcome-row"
      *ngFor="let row of outcomeRows; trackBy: trackByOutcomeRow"
    >
      <span class="outcome-icon" aria-hidden="true" [ngSwitch]="row.status">
        <span *ngSwitchCase="'done'">✓</span>
        <span *ngSwitchCase="'failed'">✕</span>
        <span *ngSwitchDefault>…</span>
      </span>
      <span class="outcome-label">{{ row.labelKey | translate }}</span>
      <span class="outcome-status">{{
        outcomeStatusLabelKey(row.status) | translate
      }}</span>
    </div>

    <p class="outcome-failure-reason" *ngIf="status.failureReason">
      {{ status.failureReason }}
    </p>

    <p class="outcome-still-processing" *ngIf="isPollingCapped">
      {{ 'SERVICE_PLAN.STEP.REVIEW.OUTCOME_STILL_PROCESSING' | translate }}
    </p>

    <div class="outcome-actions">
      <app-action-button
        *ngIf="isPollingCapped"
        kind="outline"
        color="primary"
        size="wide"
        [isDisabled]="isCheckingAgain"
        (onClick)="checkAgain()"
      >
        {{ 'SERVICE_PLAN.STEP.REVIEW.CHECK_AGAIN_BUTTON' | translate }}
      </app-action-button>

      <app-action-button
        *ngIf="status.failureReason"
        kind="outline"
        color="primary"
        size="wide"
        [isDisabled]="isRetrying"
        (onClick)="retry()"
      >
        {{ 'SERVICE_PLAN.STEP.REVIEW.RETRY_BUTTON' | translate }}
      </app-action-button>

      <app-action-button
        kind="outline"
        color="primary"
        size="wide"
        [isDisabled]="isSending"
        (onClick)="submitNewPlan()"
      >
        {{ 'SERVICE_PLAN.STEP.REVIEW.SUBMIT_NEW_PLAN_BUTTON' | translate }}
      </app-action-button>
    </div>
  </div>
</div>
